import { VALUE_10 as DEFAULT_PAGE_SIZE } from 'helpers/fieldOptions/ad/pageSize';
import { BUY_PRICE } from 'helpers/fieldOptions/ad/priceType';
import { PUBLISHED_AT_DESC as DEFAULT_SORT } from 'helpers/fieldOptions/ad/sort';
import { HP } from 'helpers/fieldOptions/car/powerType';
import { LOCALE } from 'helpers/i18n';

import {
  MERCHANT,
  PRIVATE_LISTING_SELLER,
  PRIVATE_SALE,
  RETAIL,
} from 'helpers/fieldOptions/ad/sellerType';

import {
  BODY_TYPE_NAME,
  GEOLOCATION_NAME,
  HAS_IMAGES_NAME,
  LOCALE_NAME,
  MAKE_FILTER_NAME,
  PAGE_NAME,
  PAGE_SIZE_NAME,
  POWER_TYPE_NAME,
  PRICE_TYPE_NAME,
  SELLER_TYPE_NAME,
  SORT_NAME,
} from '../constants';

export default {
  [BODY_TYPE_NAME]: {},
  [GEOLOCATION_NAME]: {},
  [LOCALE_NAME]: LOCALE,
  [MAKE_FILTER_NAME]: '',
  [PAGE_NAME]: '1',
  [PAGE_SIZE_NAME]: DEFAULT_PAGE_SIZE,
  [POWER_TYPE_NAME]: HP,
  [PRICE_TYPE_NAME]: BUY_PRICE,
  [SELLER_TYPE_NAME]: [MERCHANT, RETAIL, PRIVATE_SALE, PRIVATE_LISTING_SELLER],
  [SORT_NAME]: DEFAULT_SORT,
  [HAS_IMAGES_NAME]: true,
};
